import React from 'react'
import { makeStyles, createStyles, Box } from '@material-ui/core/'
import { useTranslation } from 'react-i18next'
import LoadingIcon from 'src/mobile/themes/components/LoadingIcon'
import EmptyDataIcon from 'src/mobile/assets/icons/errorStatus/calendar.png'

const useStyles = makeStyles((theme) =>
  createStyles({
    img: {
      display: 'block',
      maxWidth: theme.spacing(15),
    },
    button: {
      minWidth: theme.spacing(17),
      height: theme.spacing(4.5),
    },
  }),
)

const Loading = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Box
      minHeight={120}
      justifyContent="center"
      display="flex"
      flexDirection="column"
      alignItems="center"
      my="auto"
      py={2}
    >
      {props.status === 'pending' || !props.status ? (
        <LoadingIcon />
      ) : (
        <>
          {!props.hideImg && <img className={classes.img} src={EmptyDataIcon} alt="empty image" />}
          <Box mt={2} fontSize="subtitle1.fontSize" textAlign="center" color="grey.400">
            <Box mb={1} fontSize={props.fontSize || 'h4.fontSize'} color="grey.800" fontWeight="600">
              {props.title || t('tips.can_not_get_data')}
            </Box>
            <Box fontSize="body1.fontSize" color="grey.400">
              {props.subTitle || ''}
            </Box>
          </Box>
        </>
      )}
    </Box>
  )
}

export default Loading
